module.exports = __webpack_public_path__ + "src/assets/img/guest_fitness.bf1b7a64.jpg";